import React from "react";
import { BsFileEarmarkPost } from 'react-icons/bs'

const NoDataFound = ({ message = "No data found", icon: Icon = BsFileEarmarkPost }) => {
  return (
    <div className="flex flex-col items-center justify-center py-10">
      <Icon className="w-16 h-16 text-gray-400 mb-4" />
      <p className="text-gray-500 text-xl font-medium">{message}</p>
    </div>
  );
};

export default NoDataFound;
